import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import ContainerPublic from '../base/ContainerPublic'
import { GrUserNew } from 'react-icons/gr'
import { FaLockOpen } from "react-icons/fa6";
import Footer from '../base/Footer'

export default function MasterPage({ children }) {
    return (
        <ContainerPublic >
            <div className="min-h-screen flex flex-col justify-between  text-gray-800">
                <div className="fixed w-full z-40 bg-white border border-gray-200 shadow-md py-2 pe-4 mb-4 flex gap-2 justify-between">
                    <Link to="/" className='ms-3 flex items-center'>
                        <img
                            alt="Doctora OPD"
                            src="/assets/images/logo.png"
                            className="mx-auto h-9 w-auto"
                        />
                    </Link>
                    <div className='flex items-end'>
                        {/* <Link to="/create-doctor">
                            <button className="text-sm flex justify-center items-end py-1 pe-2 hover:text-blue-800 text-blue-600 ">
                                <span className='hidden sm:block ms-1'>Register as Doctor?</span>
                                <span className='sm:hidden ms-1'>Register?</span>
                            </button>
                        </Link> */}
                        <Link to="/login">
                            <button className="group relative px-5 py-2 rounded-lg bg-sky-500 shadow hover:bg-sky-600 text-white transition duration-300">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition duration-300">
                                    <FaLockOpen />
                                </span>
                                <span className="group-hover:ml-5 transition-all duration-300">Login</span>
                            </button>
                        </Link>
                    </div>
                </div>
                <div className='pt-[74px]'></div>
                {children}


                <section>
                    <Footer />
                </section>
            </div >


        </ContainerPublic >
    )
}
